import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconTravellerStatusInProgress(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path d="M16 12C16 14.2091 14.2091 16 12 16V8C14.2091 8 16 9.79086 16 12Z" fill="#EF893B" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM6 12C6 8.68629 8.68629 6 12 6C15.3137 6 18 8.68629 18 12C18 15.3137 15.3137 18 12 18C8.68629 18 6 15.3137 6 12Z"
        fill="#EF893B"
      />
    </BaseIcon>
  );
}
